import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "../../../layouts/PageTitle";
import { PERFORMANCE_REPORTS } from "./performanceReportCatalog";
import { PerformancePanel } from "../dashboard/common/PerformanceWorkspace";
import "./PerformanceReports.css";

const PerformanceReports = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t("performance.reports.title")} motherMenu={t("performance.label")} />
            <div className="performance-workspace">
                <p className="performance-reports__intro">{t("performance.reports.hub_hint")}</p>
                <PerformancePanel title={t("performance.reports.available")}>
                    <div className="performance-reports__grid">
                        {PERFORMANCE_REPORTS.map(report => (
                            <Link key={report.id} to={report.route} className="performance-reports__card">
                                <span className="performance-reports__icon"><i className={report.icon} aria-hidden="true" /></span>
                                <span>
                                    <strong>{t(report.titleKey)}</strong>
                                    <small>{t(report.descriptionKey)}</small>
                                </span>
                                <i className="fa-solid fa-chevron-right" aria-hidden="true" />
                            </Link>
                        ))}
                    </div>
                </PerformancePanel>
            </div>
        </>
    );
};

export default PerformanceReports;
